<template>
  <div class="the-sidebar-footer d-flex flex-column border-t-sm pt-1">
    <VList density="compact" nav class="py-0">
      <VListItem
        :title="rail ? undefined : 'خروج'"
        prependIcon="logout"
        class="the-sidebar-footer__logout text-error"
        rounded="lg"
        @click="onLogoutClick"
      >
        <VTooltip v-if="rail" activator="parent" location="start">
          خروج
        </VTooltip>
      </VListItem>
    </VList>

    <VListItem size="small" class="text-center pa-0 text-gray-400">
      <small class="d-flex justify-center ga-1 text-center">
        <div v-if="!rail">توسعه توسط</div>

        <a
          href="https://www.faramaham.com/"
          target="_blank"
          rel="noopener noreferrer"
          class="text-center pa-0 text-gray-400"
        >
          فرامهام
        </a>
      </small>
    </VListItem>
  </div>

  <BaseConfirmationModal
    v-model="isLogoutOpen"
    color="error"
    title="خروج از حساب کاربری"
    description="آیا مطمئن هستید که می‌خواهید از حساب کاربری خود خارج شوید؟"
    :state="ConfirmationState.Logout"
    @update:is-open="toggleLogoutModal"
    @on-submit="logout"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { VList, VListItem, VTooltip } from 'vuetify/components'
import type { Props } from './TheSideBarFooter.types'
import BaseConfirmationModal from '@/modules/Core/components/base/BaseConfirmationModal/BaseConfirmationModal.vue'
import { useAuthStore } from '@/modules/Auth/store'
import { logoutRequest } from '@/modules/Auth/requests/mutations/useLogoutMutation'
import { ConfirmationState } from '@/modules/Core/types/model/confirmationModal'

defineOptions({
  name: 'TheSideBarFooter',
})

defineProps<Props>()

const router = useRouter()
const authStore = useAuthStore()

const isLogoutOpen = ref(false)

function onLogoutClick() {
  toggleLogoutModal()
}

function toggleLogoutModal() {
  isLogoutOpen.value = !isLogoutOpen.value
}

async function logout() {
  const refreshToken = authStore.refreshToken

  try {
    if (refreshToken) {
      await logoutRequest({ refreshToken })
    }
  } catch {
    // Best-effort server logout; local session is always cleared.
  } finally {
    authStore.logout()
    toggleLogoutModal()
    await router.push('/login')
  }
}
</script>

<style scoped>
.the-sidebar-footer__logout :deep(.v-list-item__prepend .v-icon) {
  color: rgb(var(--v-theme-error));
}

.the-sidebar-footer__logout :deep(.v-list-item-title) {
  color: rgb(var(--v-theme-error));
  font-weight: 500;
}
</style>
